// Запускаем расширения
import '@/extensions/yandex';
import '@/extensions/data-layer';
import '@/extensions/facebook';
import '@/extensions/vk';

document.addEventListener('DOMContentLoaded', function() {
  if (typeof InSales != 'undefined' && InSales.Cart && Cart.constructor == InSales.Cart) {
    console.warn('Возможен дубль корзины, используются 2 версии common.js');
  }

  if (window._ && window._.VERSION !== '4.17.21') {
    console.warn('Задвоение библиотеки lodash. Дубль - ' + window._.VERSION);
  }
});

window.Site = {};
